// Price/Time measurment tool
/* 
import Overlay from '../../mixins/overlay.js'
import Tool from '../../mixins/tool.js'*/
import Seg from './primitives/seg.js';
import Line from './primitives/line.js';
import Ray from './primitives/ray.js';
import Icons from './icons.json';
import Pin from './primitives/pin.js';

import { Overlay, Tool } from 'trading-vue-js';

export default {
    name: 'Parallel_Lines',
    mixins: [Overlay, Tool],
    methods: {
        meta_info() {
            return { author: 'C451', version: '2.0.1' };
        },
        tool() {
            return {
                // Descriptor for the tool
                //group: 'Measurements',
                //icon: Icons['pline.png'],
                group: 'Parallel_Lines',
                icon: Icons['pline.png'],
                type: 'Segments',
                hint: 'Parallel Lines',
                data: [], // Default data
                settings: { price: true, time: true, shiftMode: false }, // Default settings
                //hidden: true,
                mods: {
                    First_is_Line: {
                        // Rewrites the default setting fields
                        settings: { ray: true },
                        icon: Icons['pline_first.png'],
                    },
                    Second_is_Line: {
                        // Rewrites the default setting fields
                        settings: { extended: true },
                        icon: Icons['pline_second.png'],
                    },
                    Double_Lines: {
                        // Rewrites the default setting fields
                        settings: { extended: true, ray: true },
                        icon: Icons['pline_double.png'],
                    },
                },
                /* mods: {
                    Time: {
                        // Rewrites the default setting fields
                        icon: Icons['time_range.png'],
                        settings: { price: false, time: true },
                    },
                    PriceTime: {
                        // Rewrites the default setting fields
                        icon: Icons['price_time.png'],
                        settings: { price: true, time: true },
                    },
                    ShiftMode: {
                        // Rewrites the default setting fields
                        settings: {
                            price: true,
                            time: true,
                            shiftMode: true,
                        },
                        hidden: true,
                    },
                }, */
            };
        },
        // Called after overlay mounted
        init() {
            if (this.settings.$state != 'finished') {
                this.sett['color'] = window.localStorage.getItem('linecolor') || '#42b28a';
                this.sett['lineWidth'] = window.localStorage.getItem('linewidth') || 0.9;
            }
            // First pin is settled at the mouse position
            this.pins.push(
                new Pin(this, 'p1', {
                    hidden: this.shift,
                })
            );
            // Second one is following mouse until it clicks
            this.pins.push(
                new Pin(this, 'p2', {
                    state: 'tracking',
                    hidden: this.shift,
                })
            );
            this.pins.push(
                new Pin(this, 'p3', {
                    state: 'waiting',
                    hidden: this.shift,
                })
            );

            this.pins[1].on('settled', () => {
                console.log(this.pins);
                this.pins[2].state = this.pins[2].state == 'waiting' ? 'tracking' : this.pins[2].state;
                this.pins[2].on('settled', () => {
                    // Call when current tool drawing is finished
                    // (Optionally) reset the mode back to 'Cursor'
                    this.set_state('finished');
                    this.$emit('drawing-mode-off');
                    // Deselect the tool in shiftMode
                    if (this.shift)
                        this._$emit('custom-event', {
                            event: 'object-selected',
                            args: [],
                        });
                });
            });
        },
        draw(ctx) {
            if (!this.p1 || !this.p2 || !this.p3) return;
            //console.log('#########', this.p3);
            const layout = this.$props.layout;
            const dir = Math.sign(this.p2[1] - this.p1[1]);
            const xm = layout.t2screen((this.p1[0] + this.p2[0]) * 0.5);
            ctx.lineWidth = this.line_width;
            ctx.strokeStyle = this.color;

            let x1 = this.p1[0];
            let y1 = this.p1[1];
            let x2 = this.p2[0];
            let y2 = this.p2[1];
            let x3 = this.p3[0];
            let y3 = this.p3[1];
            let deltaX = x2 - x1;
            let deltaY = y2 - y1;

            ctx.beginPath();
            if (this.sett.ray) {
                new Line(this, ctx).draw(this.p1, this.p2);
            } else {
                new Seg(this, ctx).draw(this.p1, this.p2);
            }
            if (x3 != x1 && y3 != y1) {
                //ctx.moveTo(x3, y3);
                //ctx.lineTo(x3 - deltaX, y3 - deltaY);

                if (this.sett.extended) {
                    new Line(this, ctx).draw(this.p3, [x3 - deltaX, y3 - deltaY]);
                } else {
                    new Seg(this, ctx).draw(this.p3, [x3 - deltaX, y3 - deltaY]);
                }
            }
            ctx.stroke();
            this.draw_value(ctx, dir, xm, y2);
            this.render_pins(ctx);
        },
        draw_value(ctx, dir, xm, y) {
            ctx.font = this.new_font;
            // Price delta (anf percent)
            let d$ = (this.p2[1] - this.p1[1]).toFixed(this.prec);
            let p = (100 * (this.p2[1] / this.p1[1] - 1)).toFixed(this.prec);
            // Map interval to the actual tf (in ms)
            let f = (t) => this.layout.ti_map.smth2t(t);
            let dt = f(this.p2[0]) - f(this.p1[0]);
            let tf = this.layout.ti_map.tf;
            // Bars count (through the candle index)
            let f2 = (t) => {
                let c = this.layout.c_magnet(t);
                let cn = this.layout.candles || this.layout.master_grid.candles;
                return cn.indexOf(c);
            };
            // Bars count (and handling the negative values)
            let b = f2(this.p2[0]) - f2(this.p1[0]);
            // Format time delta
            // Format time delta
            let dtstr = this.t2str(dt);
            let text = [];
            if (this.price) text.push(`${d$}  (${p}%)`);
            if (this.time) text.push(`${b} bars, ${dtstr}`);
            text = text.join('\n');
            // "Multiple" fillText
            let lines = text.split('\n');
            let w = Math.max(...lines.map((x) => ctx.measureText(x).width + 20), 100);
            let n = lines.length;
            let h = 20 * n;
            ctx.fillStyle = this.value_back;
            ctx.fillRect(xm - w * 0.5, y - (10 + h) * dir, w, h * dir);
            ctx.fillStyle = this.value_color;
            ctx.textAlign = 'center';
            lines.forEach((l, i) => {
                ctx.fillText(l, xm, y + (dir > 0 ? 20 * i - 20 * n + 5 : 20 * i + 25));
            });
        },
        // Formats time from ms to `1D 12h` for example

        t2str(t) {
            let sign = Math.sign(t);
            let abs = Math.abs(t);
            let tfs = [
                [1000, 's', 60],
                [60000, 'm', 60],
                [3600000, 'h', 24],
                [86400000, 'D', 7],
                [604800000, 'W', 4],
                [2592000000, 'M', 12],
                [31536000000, 'Y', Infinity],
                [Infinity, 'Eternity', Infinity],
            ];
            for (var i = 0; i < tfs.length; i++) {
                tfs[i][0] = Math.floor(abs / tfs[i][0]);
                if (tfs[i][0] === 0) {
                    let p1 = tfs[i - 1];
                    let p2 = tfs[i - 2];
                    let txt = sign < 0 ? '-' : '';
                    if (p1) {
                        txt += p1.slice(0, 2).join('');
                    }
                    let n2 = p2 ? p2[0] - p1[0] * p2[2] : 0;
                    if (p2 && n2) {
                        txt += ' ';
                        txt += `${n2}${p2[1]}`;
                    }
                    return txt;
                }
            }
        },
        use_for() {
            return ['Parallel_Lines'];
        },
        data_colors() {
            return [this.color];
        },
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            return this.$props.settings;
        },
        p1() {
            return this.$props.settings.p1;
        },
        p2() {
            return this.$props.settings.p2;
        },
        p3() {
            return this.$props.settings.p3;
        },
        line_width() {
            return this.sett.lineWidth || 0.9;
        },
        color() {
            return this.sett.color || this.$props.colors.cross;
        },
        back_color() {
            return this.sett.backColor || '#9b9ba316';
        },
        value_back() {
            return this.sett.valueBack || '#9b9ba316';
        },
        value_color() {
            return this.sett.valueColor || this.$props.colors.text;
        },
        prec() {
            return this.sett.precision || 2;
        },
        new_font() {
            return '12px ' + this.$props.font.split('px').pop();
        },
        price() {
            return this.sett.price || true;
        },
        time() {
            return this.sett.time || true;
        },
        shift() {
            return this.sett.shiftMode || false;
        },
    },
    data() {
        return {};
    },
};
